exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bannerImage[data-v-47284e53] {\n  -o-object-fit: cover;\n     object-fit: cover;\n}", ""]);

// exports
